import { z } from 'zod';

export const processingWindowSchema = z.enum(['1h', '6h', '24h', '7d']);
export type ProcessingWindow = z.infer<typeof processingWindowSchema>;

export const processingAppCountsSchema = z.object({
  appId: z.string(),
  appName: z.string(),
  queued: z.number(),
  completed: z.number(),
  failed: z.number(),
  avgWaitSeconds: z.number().nullable(),
  avgWorkSeconds: z.number().nullable(),
});
export type ProcessingAppCounts = z.infer<typeof processingAppCountsSchema>;

export const processingOverviewSchema = z.object({
  window: processingWindowSchema,
  appId: z.string().nullable(),
  queue: z.object({
    waiting: z.number(),
    active: z.number(),
    delayed: z.number(),
    failed: z.number(),
    completed: z.number(),
  }),
  backlog: z.number(),
  throughputPerMin: z.number(),
  etaSeconds: z.number().nullable(),
  workerAlive: z.boolean(),
  avgWaitSeconds: z.number().nullable(),
  avgWorkSeconds: z.number().nullable(),
  failedInWindow: z.number(),
  byApp: z.array(processingAppCountsSchema),
  generatedAt: z.string(),
});
export type ProcessingOverview = z.infer<typeof processingOverviewSchema>;

export const processingSeriesSchema = z.object({
  window: processingWindowSchema,
  bucketSeconds: z.number(),
  points: z.array(
    z.object({
      t: z.string(),
      queued: z.number(),
      completed: z.number(),
      failed: z.number(),
      backlog: z.number(),
      etaSeconds: z.number().nullable(),
    }),
  ),
});
export type ProcessingSeries = z.infer<typeof processingSeriesSchema>;
